import MediaGalleryOverlayMobile from './MediaGalleryOverlayMobile';

export default MediaGalleryOverlayMobile;